import { CreateClinicalDocsByEmail } from '~/domain/usecases/clinicalDocs/remote';
import { HttpClient, HttpStatusCode } from '~/data/protocols/http';
import {
  InvalidCredentialsError,
  UnexpectedError,
  NotFound,
} from '~/domain/errors';
import '~/infra/global/variables';

export class RemoteCreateClinicalDocsByEmail
  implements CreateClinicalDocsByEmail
{
  private readonly url: string;

  private readonly httpClient: HttpClient<CreateClinicalDocsByEmail.Model>;

  constructor(
    url: string,
    httClient: HttpClient<CreateClinicalDocsByEmail.Model>,
  ) {
    this.url = url;
    this.httpClient = httClient;
  }

  createByEmail = async (
    params: CreateClinicalDocsByEmail.Params,
  ): Promise<CreateClinicalDocsByEmail.Model> => {
    const httpResponse = await this.httpClient.request({
      url: `${this.url}/${params.docId}/email`,
      method: 'post',
      body: {
        to: params.to,
      },
    });
    switch (httpResponse.statusCode) {
      case HttpStatusCode.noContent:
        return httpResponse.body;
      case HttpStatusCode.notFound:
        throw new NotFound();
      case HttpStatusCode.unauthorized:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError();
    }
  };
}
